const DEFAULT_STACK_BEHAVIOR="replace",DEFAULT_ENABLE_DISMISS_ON_CLOSE=!0;export{DEFAULT_STACK_BEHAVIOR,DEFAULT_ENABLE_DISMISS_ON_CLOSE};